import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M18 2a2 2 0 0 1 2 2v16a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-16a2 2 0 0 1 2 -2z","key":"svg-0"}]]

const IconColumns1Filled = createReactComponent('filled', 'columns-1-filled', 'Columns1Filled', __iconNode);

export default IconColumns1Filled;